module.exports = __webpack_public_path__ + "static/img/1.effa9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/benjyfishy/1.png
// module id = kucn
// module chunks = 35